module.exports = __webpack_public_path__ + "img/85287.78090909.svg";